import { TextField, Box, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import React from "react";

const OTPMultiEntryComponent = ({ otpHint = "0000", cbSubmit, cbClear }) => {
  const clear = () => {};

  if (cbClear) {
    cbClear(clear);
  }

  let inputRefs = Array(6).fill(null);

  const keyUpFn = (id, inputRefs) => (e) => {
    const prev = id > 0 ? inputRefs[id - 1] : null;
    const next = id < inputRefs.length - 1 ? inputRefs[id + 1] : null;
    if (e.keyCode === 8 || e.keyCode === 37) {
      if (prev) {
        prev.select();
      }
    } else if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 65 && e.keyCode <= 90) ||
      (e.keyCode >= 96 && e.keyCode <= 105) ||
      e.keyCode === 39
    ) {
      if (next) {
        next.select();
      } else {
        if (cbSubmit) {
          cbSubmit(inputRefs.reduce((acc, elem) => acc + elem.value, ""));
        }
      }
    }
  };
  return (
    <Grid container>
      <Grid>
        <Box
          tabIndex={0}
          aria-label={`OTP prefix hint: ${otpHint.split("").join(" ")}`}
        >
          <Grid container>
            <Grid>
              {otpHint.split("").map((elem, idx) => (
                <TextField
                  key={"otpHint-" + idx}
                  aria-hidden="true"
                  disabled
                  id={"otpHint-" + idx}
                  onChange={(event) => console.log(event)}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: "center" },
                  }}
                  autoComplete="one-time-pin"
                  style={{ width: "2.3rem", padding: "0.2rem" }}
                  value={elem}
                />
              ))}
            </Grid>
          </Grid>
          <Typography
            sx={{
              position: "absolute",
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: "hidden",
              clip: "rect(0,0,0,0)",
              whiteSpace: "nowrap",
              border: 0,
            }}
          >
            {`OTP prefix hint: ${otpHint.split("").join(" ")}`}
          </Typography>
        </Box>
      </Grid>
      <Grid>
        <span
          className="splitter"
          style={{
            width: "1rem",
            padding: "0.3rem",
            fontSize: "2rem",
            textAlign: "center",
          }}
        >
          &ndash;
        </span>
      </Grid>
      <Grid>
        {Array(6)
          .fill(null)
          .map((elem, idx) =>
            idx === 0 ? (
              <TextField
                key={"otpEntry-" + idx}
                required
                id={"otpEntry-" + idx}
                onChange={(event) => console.log(event)}
                inputProps={{
                  maxLength: 1,
                  ref: (input) => {
                    inputRefs[idx] = input;
                  },
                  style: { textAlign: "center" },
                  inputMode: "numeric",
                }}
                aria-label="OTP Entry 1 of 6"
                autoComplete="one-time-pin"
                style={{ width: "2.3rem", padding: "0.2rem" }}
                onKeyUp={keyUpFn(idx, inputRefs)}
                autoFocus
              />
            ) : (
              <TextField
                key={"otpEntry-" + idx}
                required
                id={"otpEntry-" + idx}
                aria-label={"OTP Entry " + (idx + 1) + " of 6"}
                onChange={(event) => console.log(event)}
                inputProps={{
                  maxLength: 1,
                  ref: (input) => {
                    inputRefs[idx] = input;
                  },
                  style: { textAlign: "center" },
                  inputMode: "numeric",
                }}
                autoComplete="one-time-pin"
                style={{ width: "2.3rem", padding: "0.2rem" }}
                onKeyUp={keyUpFn(idx, inputRefs)}
              />
            )
          )}
      </Grid>
    </Grid>
  );
};

export default OTPMultiEntryComponent;
